// extracted by mini-css-extract-plugin
export default {"deep-learn":"DeepLearn_deep-learn__tZHS2","title-pic":"DeepLearn_title-pic__1gZz5","car":"DeepLearn_car__bTfIa"};